<script setup>
import { useRoute, useRouter } from 'vue-router';
import { stateManager } from '@/stateManager';
import { watch } from 'vue';

  const router = useRouter();
  const route = useRoute();

  watch(() => route.fullPath, (to, from) => { sideNavClose() })

  function goHome() {
      if (route.name != 'home') 
        router.push({ name: "home" });
  }

  function sideNavClose () {
        document.getElementById('sideNav').style.width = "0";
        document.getElementById('bodyOverlay').style.height = "0%";
        document.getElementById('bodyOverlay').style.opacity = "0";
        // document.getElementById('hideOnMenuOpen_issue').style.opacity = "1";
        document.body.style.overflow = 'scroll';
  }

  function getFavoritesNumber() {
    return 11;
  }
</script>

<template>
    <div class="body-overlay" id="bodyOverlay" v-on:click="sideNavClose()"></div>
    <div class="sideNav" id="sideNav">
        <div class="sideNav-header">
          <div class="navbar-logo">
            <img class="logo" src="@/assets/img/logo.png" @click="goHome">
            <p @click="goHome">Salmi<span></span> Biblici</p>
          </div>
          <a href="javascript:void(0)" class="sideNav-closeButton" v-on:click="sideNavClose()">&times;</a>
        </div>

        <router-link to="/favorites">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" />
        </svg>
        <span>Preferiti <b class="favoriteNumber">{{stateManager.total_favorite_count}}</b></span></router-link>
        
      <router-link to="/parole-di-luce">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z" />
        </svg>
        <span>Parole di Luce</span></router-link>

        <a href="https://paypal.com/paypalme/castenettoa">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M16 12C18.76 12 21 9.76 21 7S18.76 2 16 2 11 4.24 11 7 13.24 12 16 12M21.45 17.6C21.06 17.2 20.57 17 20 17H13L10.92 16.27L11.25 15.33L13 16H15.8C16.15 16 16.43 15.86 16.66 15.63S17 15.12 17 14.81C17 14.27 16.74 13.9 16.22 13.69L8.95 11H7V20L14 22L22.03 19C22.04 18.47 21.84 18 21.45 17.6M5 11H.984V22H5V11Z" />
          </svg>
          <span>Fai una Donazione</span></a>

          <router-link to="/blog/changelog" style="opacity: .65;">
         <svg  style="width:24px;height:24px" class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
    <path
      d="M13 3a9 9 0 1 0 9 9h-2a7 7 0 1 1-7-7V3m-1 4h2v5l4.28 2.54-.86 1.23L12 13V7z"
    />
  </svg>
        <span>Changelog</span></router-link>
    </div>
</template>

<style scoped lang="scss">

</style>
